module.exports = __webpack_public_path__ + "img/20180815_152858_221.9658dd4a.jpg";